var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,3.5a.833.833,0,0,1,.833.833V11a.833.833,0,0,1-.833.833H4.333a.833.833,0,1,1,0-1.667h5.833V4.333A.833.833,0,0,1,11,3.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,8.333A.833.833,0,0,1,8.333,7.5H15a.833.833,0,0,1,0,1.667H9.167V15A.833.833,0,0,1,7.5,15Z",
    transform: "translate(2.667 2.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c641137d4672379a1ea8985336f5ef48.svg";
export { ForwardRef as ReactComponent };